<div *ngIf="building; else noBuilding" class="building-card"
     [nbTooltip]="building.sectionText"
     nbTooltipPlacement="top">
  <nb-icon class="building-card__icon" pack="eva" icon="home-outline"></nb-icon>
  <span class="building-card__text">{{ building.sectionText }}</span>
  <button class="building-card__link" nbButton ghost size="tiny" (click)="navigate($event)" nbTooltip="Gebäude öffnen">
    <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
  </button>
</div>

<ng-template #noBuilding>
  <span class="text-hint">—</span>
</ng-template>
